import { ColorLiterals, ColorOptionKeys } from '../themes';
import { useTheme } from './useTheme';

export interface UseColorProps {
  color: ColorLiterals;
  option?: ColorOptionKeys;
}

/**
 * hook that will calculate a color from our theme to easily apply to components. If color
 * does not match in theme, it will return color passed in.
 */
export const useColor = ({ color, option = 'main' }: UseColorProps): string => {
  let mutatedOption = option;
  const theme = useTheme();

  if (color === 'warning') {
    mutatedOption = 'dark';
  }

  // @ts-expect-error
  return theme?.palette?.[color]?.[mutatedOption] || color;
};
